import { ROOT } from "../config";

export const GET_PUBLIC_USER = () => {
  return `${ROOT}/api/public/user`;
};
